// extracted by mini-css-extract-plugin
module.exports = {"form-buttons":"FormHeader_form-buttons__1Vdxc","btn-with-margin":"FormHeader_btn-with-margin__2RrNO"};